import { render, staticRenderFns } from "./BlockFeaturedVideoCopy.vue?vue&type=template&id=51b63313&scoped=true&"
import script from "./BlockFeaturedVideoCopy.vue?vue&type=script&lang=js&"
export * from "./BlockFeaturedVideoCopy.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeaturedVideoCopy.vue?vue&type=style&index=0&id=51b63313&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b63313",
  null
  
)

export default component.exports